import { __read, __values } from "tslib";
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHasSelectedSubsidies, getInitialPrice, getIsSubsidiesModalOpen, getSelectedSubsidies, getSelectedSubsidiesPricesByPassengers, getSubsidiesByPassengers, getSubsidiesResults, getTotalSelectedSubsidiesPrices } from '../../../Checkout/store/subsidies/selectors';
import Dialog from '@material-ui/core/Dialog';
import { getPassengerState } from '../../../Checkout/store/passengers/selectors';
import SubsidiesResultPassenger from '../SubsidiesResultPassenger/SubsidiesResultPassenger';
import { useCallback } from 'react';
import { selectSubsidy, setSubsidiesResultsOpen } from '../../../Checkout/store/subsidies/actions';
import { CloseClear } from '../../../Icons';
import { IconButton } from '@mui/material';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '../../../Button';
import { Money } from '../../../Money';
import cn from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../utils';
var SubsidiesResult = function (_a) {
    var _b;
    var onSubmit = _a.onSubmit;
    var theme = useTheme('Subsidies').SubsidiesResult;
    var t = useTranslation('Subsidies').t;
    var isOpen = useSelector(getIsSubsidiesModalOpen);
    var subsidiesResults = useSelector(getSubsidiesResults);
    var availableSubsidiesByPassengers = useSelector(getSubsidiesByPassengers);
    var orderTravellers = useSelector(getPassengerState);
    var selectedSubsidies = useSelector(getSelectedSubsidies);
    var selectedSubsidiesPricesByPassengers = useSelector(getSelectedSubsidiesPricesByPassengers);
    var totalPriceWithSelectedSubsidies = useSelector(getTotalSelectedSubsidiesPrices);
    var initialPrice = useSelector(getInitialPrice);
    var hasSelectedSubsidies = useSelector(getHasSelectedSubsidies);
    var dispatch = useDispatch();
    var isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    var handleClose = useCallback(function () {
        dispatch(setSubsidiesResultsOpen(false));
    }, [isOpen, dispatch]);
    var handleSelectSubsidies = useCallback(function (passengerId, subsidies) {
        var e_1, _a;
        try {
            for (var subsidies_1 = __values(subsidies), subsidies_1_1 = subsidies_1.next(); !subsidies_1_1.done; subsidies_1_1 = subsidies_1.next()) {
                var subsidy = subsidies_1_1.value;
                dispatch(selectSubsidy({
                    subsidyId: subsidy.subsidyId,
                    segmentId: subsidy.segmentId,
                    passengerId: passengerId
                }));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (subsidies_1_1 && !subsidies_1_1.done && (_a = subsidies_1.return)) _a.call(subsidies_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }, [isOpen, selectedSubsidies, dispatch]);
    var handleSubmit = useCallback(function () {
        onSubmit(selectedSubsidies);
        handleClose();
    }, [selectedSubsidies, handleClose]);
    var header = (React.createElement("div", { className: theme.header },
        React.createElement("span", null, t('Available subsidies for passengers')),
        React.createElement(IconButton, { size: 'small', onClick: handleClose, className: theme.button }, CloseClear)));
    var footer = (React.createElement("div", { className: theme.footer },
        React.createElement(ActionButton, { onClick: handleSubmit, className: theme.continueBtn, size: 'common' }, t('Continue'))));
    var pricesDescription = (React.createElement("div", { className: theme.priceDescription },
        React.createElement("div", { className: theme.priceDescriptionHeader }, t('Flight price')),
        hasSelectedSubsidies ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: theme.priceDescriptionRow },
                t('Before subsidies apply'),
                ":",
                React.createElement(Money, { money: initialPrice, moneyClassName: cn(theme.money) })),
            React.createElement("div", { className: theme.priceDescriptionRow },
                t('After subsidies apply'),
                ":",
                React.createElement(Money, { money: totalPriceWithSelectedSubsidies, moneyClassName: cn(theme.money, theme.money_new) })))) : (React.createElement("div", { className: theme.priceDescriptionRow },
            t('Before subsidies apply'),
            ":",
            React.createElement(Money, { money: initialPrice, moneyClassName: cn(theme.money) })))));
    return (React.createElement(Dialog, { open: isOpen, fullWidth: true, maxWidth: 'lg', classes: { paper: cn(theme.paper, (_b = {}, _b[theme.paper_mobile] = isMobile, _b)) }, fullScreen: isMobile },
        header,
        Object.entries(availableSubsidiesByPassengers).map(function (_a) {
            var _b = __read(_a, 2), passengerId = _b[0], availableSubsidies = _b[1];
            var currentTraveller = orderTravellers.find(function (orderTraveller) { return orderTraveller.id === passengerId; });
            if (!subsidiesResults[currentTraveller.id]) {
                return null;
            }
            return (React.createElement(SubsidiesResultPassenger, { key: passengerId, selectedSubsidiesPrice: selectedSubsidiesPricesByPassengers[currentTraveller.id], selectedSubsidies: selectedSubsidies[currentTraveller.id], onSubsidySelect: handleSelectSubsidies, passenger: currentTraveller, subsidiesResult: subsidiesResults[passengerId], availableSubsidies: availableSubsidiesByPassengers[passengerId] }));
        }),
        React.createElement("div", { className: theme.bottom },
            pricesDescription,
            footer)));
};
export default SubsidiesResult;
